import React, {HTMLAttributes} from "react";
import {Icon, Tooltip, Typography} from "antd";

export interface CstWarningProps extends HTMLAttributes<HTMLSpanElement>{
    renderMessage?: (defaultMsg: string) => React.ReactNode
}

const TOOLTIP_TEXT = "You must enter a time in CST (Central Standard Time) regardless of your local timezone.";

export default function CstWarning({ renderMessage, ...restProps }: CstWarningProps){

    function getTooltipText(){
        if (renderMessage) {
            return renderMessage(TOOLTIP_TEXT);
        }

        return TOOLTIP_TEXT;
    }

    return <span {...restProps}>
        <Tooltip title={getTooltipText()}>
            <Typography.Text type="warning">CST <Icon type="question-circle" /></Typography.Text>
        </Tooltip>
    </span>
}